import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef
} from "@angular/core";
import { Subscription } from "rxjs";

import { OptionsListComponent } from "./base-options-list.component";
import { SelectClasses } from "./base-select-classes";
import { BaseSelectComponent } from "./base-select.component";
import { OptionLayoutContext } from "./option-layout.directive";

@Directive()
export abstract class BaseOptionComponent<Model> implements OnInit, OnDestroy {
  @Input()
  option: Model;

  get optionLayoutTemplate(): TemplateRef<OptionLayoutContext<Model>> {
    return this.selectElem.optionLayoutTemplate;
  }

  get selectClasses(): SelectClasses {
    return this.selectElem.selectClasses;
  }

  get focused(): boolean {
    return this.option === this.optionsList.focusedOption.value;
  }

  @HostListener("mousemove", ["$event"])
  onMouseMove(): void {
    if (
      !this.optionsList.focusMouse ||
      this.option === this.optionsList.focusedOption.value
    ) {
      return;
    }
    this.optionsList.updateFocusedOption(this.option);
  }

  @HostListener("mouseleave", ["$event"])
  onMouseLeave(): void {
    if (!this.optionsList.focusMouse) {
      return;
    }
    this.optionsList.updateFocusedOption(undefined);
  }

  constructor(
    protected selectElem: BaseSelectComponent<Model, any, any>,
    protected optionsList: OptionsListComponent<Model>,
    public elemRef: ElementRef,
    protected renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(
      this.elemRef.nativeElement,
      this.selectClasses.option
    );
    this.initFocusedOptionSubscription();
  }

  ngOnDestroy(): void {
    if (this.focusedOptionSubscription != null) {
      this.focusedOptionSubscription.unsubscribe();
      this.focusedOptionSubscription = undefined;
    }
  }

  private focusedOptionSubscription?: Subscription;
  private initFocusedOptionSubscription(): void {
    let wasFocused: boolean = false;
    this.focusedOptionSubscription = this.optionsList.focusedOption.subscribe(
      (option: Model) => {
        if (option === this.option) {
          this.renderer.addClass(
            this.elemRef.nativeElement,
            this.selectClasses.optionFocused
          );
          wasFocused = true;
        } else if (wasFocused) {
          wasFocused = false;
          this.renderer.removeClass(
            this.elemRef.nativeElement,
            this.selectClasses.optionFocused
          );
        }
      }
    );
  }
}
